module.exports = __webpack_public_path__ + "static/media/1 tiger samurai japanese leg sleeve .1280x1707.ad19bc99.webp";